import { Award, CheckCircle, Clock, Shield, Star, User } from 'lucide-react';

const BidCard = ({ bid, index, roofData, onSelect,no }) => {
  const getBadge = () => {
    if (index === 0) {
      return (
        <div className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-center py-3 rounded-t-3xl text-sm font-semibold">
          #{index + 1} BEST VALUE
        </div>
      );
    }
    if (bid.premium) {
      return (
        <div className="bg-gradient-to-r from-purple-500 to-indigo-500 text-white text-center py-3 rounded-t-3xl text-sm font-semibold">
          #{index + 1} PREMIUM
        </div>
      );
    }
    return (
      <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white text-center py-3 rounded-t-3xl text-sm font-semibold">
        #{index + 1} BID
      </div>
    );
  };

  return (
    <div
      className="bg-white rounded-3xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 flex flex-col h-full"
      data-testid={`bid-card-${bid.id}`}
    >
      <div className="relative">{getBadge()}</div>

      <div className="p-6 flex flex-col flex-grow">
        {/* Contractor Info */}
        <div className="flex items-center space-x-4 mb-6">
          <img
            src={bid.avatar}
            alt={bid.contactName}
            className="w-16 h-16 rounded-full object-cover border-2 border-gray-100"
          />
          <div className="flex-1">
            <h3 className="text-xl font-bold text-gray-900 leading-tight">
              {bid.contractor}
            </h3>
            <p className="text-gray-600 text-sm">{bid.contactName}</p>
            <div className="flex items-center space-x-2 mt-2">
              <div className="flex items-center">
                <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                <span className="text-sm font-semibold text-gray-900 ml-1">
                  {bid.rating}
                </span>
              </div>
              <span className="text-sm text-gray-500">
                ({bid.reviews} reviews)
              </span>
              {bid.verified && (
                <div className="flex items-center space-x-1">
                  <Shield className="w-4 h-4 text-emerald-600" />
                  <span className="text-xs text-emerald-600 font-medium">✓</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Pricing */}
        <div className="text-center p-4 bg-gray-50 rounded-2xl mb-2">
          <div className="text-lg font-bold text-blue-600 mb-1">
            $
            {Number(
              bid.pricePerSqFt ||
                bid.price /
                  Number(
                    (roofData?.totalArea || '').replace(/[^\d]/g, '') || 1
                  )
            ).toFixed(2)}
            /sq ft
          </div>
          <div className="text-xs text-gray-500 mb-3">Rate per square foot</div>
          <div className="text-sm text-gray-600 mb-2 bg-white rounded-lg p-2">
            <div className="flex items-center justify-center space-x-1">
              <span>${Number(bid.pricePerSqFt || 0).toFixed(2)}</span>
              <span>×</span>
              <span>
                {(roofData?.totalArea || '0')
                  .toString()
                  .match(/[\d,]+/)?.[0] || '0'}{' '}
                sq ft
              </span>
              <span>=</span>
            </div>
          </div>
          <div className="text-2xl font-bold text-emerald-600">
            ${(bid.price || 0).toLocaleString()}
          </div>
          <div className="text-sm text-gray-600">Total Project Cost</div>
        </div>

        {/* Details Grid */}
        <div className="grid grid-cols-3 gap-4 mb-6">
          <div className="flex items-center space-x-2">
            <Clock className="w-4 h-4 text-gray-400" />
            <div>
              <div className="text-xs text-gray-500">Timeline</div>
              <div className="font-semibold text-gray-900 text-sm">
                {bid.timeline}
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Award className="w-4 h-4 text-gray-400" />
            <div>
              <div className="text-xs text-gray-500">Experience</div>
              <div className="font-semibold text-gray-900 text-sm">
                {bid.experience}
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <User className="w-4 h-4 text-gray-400" />
            <div>
              <div className="text-xs text-gray-500">Completed</div>
              <div className="font-semibold text-gray-900 text-sm">
                {bid.completedJobs} jobs
              </div>
            </div>
          </div>
        </div>

        {/* Specialties */}
        <div className="mb-6">
          <div className="text-sm font-semibold text-gray-900 mb-3">
            Specialties
          </div>
          <div className="flex flex-wrap gap-2">
            {(bid.specialties || []).slice(0, 3).map((specialty, idx) => (
              <span
                key={idx}
                className="bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-full border border-blue-200"
              >
                {specialty}
              </span>
            ))}
          </div>
        </div>

        {/* What's Included */}
        <div className="mb-6 flex-grow">
          <div className="text-sm font-semibold text-gray-900 mb-3">
            What's Included
          </div>
          <div className="space-y-2">
            {(bid.included || []).slice(0, 3).map((item, idx) => (
              <div key={idx} className="flex items-start space-x-2">
                <CheckCircle className="w-3 h-3 text-emerald-600 mt-1 flex-shrink-0" />
                <span className="text-xs text-gray-700">{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Select Button */}
        <div className="space-y-3 mt-auto">
       {!no &&   <button
            data-testid={`select-bid-${bid.id}`}
            onClick={() => onSelect(bid)}
            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 rounded-2xl font-semibold hover:from-blue-700 hover:to-blue-800 transition-all duration-300 transform hover:scale-105"
          >
            Select This Bid
          </button>}
        </div>
      </div>
    </div>
  );
};

export default BidCard;
